export const getObjProp = (obj: Record<string, any>) => (prop: string) =>
  obj[prop];
